var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"size":"middle","columns":_vm.columns,"data-source":_vm.data,"loading":_vm.loading,"pagination":false,"row-key":"id"}})}
var staticRenderFns = []

export { render, staticRenderFns }